<script lang="ts">
  import '../../../app.postcss'
  import { Root } from '$lib/components/shadcn/accordion'
  import FaqCard from './FAQCard.svelte'

  const faqData = [
    {
      title: 'What is Butane?',
      collapseContent:
        'Butane is a decentralized synthetic assets protocol built on the Cardano blockchain using Plutus smart contracts.',
    },
    {
      title: 'Why should I use Butane?',
      collapseContent:
        'Butane offers a streamlined and powerful interface for managing financial strategies and portfolios that leverage synthetic assets. It puts decentralization and transparency at the forefront while not sacrificing the overall user experience, maintaining high throughput and minimal fees.',
    },
    {
      title: 'What is a synthetic asset?',
      collapseContent:
        'Synthetics are tokenized derivative assets. They are derived from real-world assets, whose prices are tracked on-chain via price feed mechanisms.',
    },
    {
      title: 'What is a CDP?',
      collapseContent:
        'All synthetics on Butane are backed by collateral. This is facilitated by opening Collateralized Debt Positions (CDPs) - positions created when a user locks up CNT collateral and mints synthetic tokens as debt.',
    },
  ]
</script>

<div class="mx-auto max-w-screen-xl-desktop">
  <section class="relative mx-2 flex flex-col items-center space-y-14">
    <h2 class="font-cirka text-[48px]">FAQs</h2>
    <Root type="single" class="w-[95%] rounded-none border-none sm-desktop:w-[60%]">
      {#each faqData as faq (faq.title)}
        <FaqCard title={faq.title} collapseContent={faq.collapseContent} />
      {/each}
    </Root>
  </section>
</div>

<style lang="postcss">
  @media (min-width: 1240px) {
    h2 {
      font-size: 110px;
    }
  }
</style>
